module.exports = __webpack_public_path__ + "img/lian.26f96737.png";